const theme = {
  colors: {
    primary: '#053dbf',
    accent: '#E56425',
    accentHover: '#E78A5B',
    background: '#FFFFFF',
    backgroundLight: '#F8F9FD',
    backgroundGray: '#F1F2F4',
    textDark: '#020524',
    textMuted: '#5E6072',
    textLabel: '#55555F',
    border: '#D8E0E8',
    borderLight: '#E1E1E9',
    divider: '#DCDDDF',
    success: '#56CA00',
    error: '#FF4C51',
    warning: '#FFB400',
    info: '#16B1FF',
    white: '#FFFFFF',
    black: '#000000',
  },
  fontFamily: "'Montserrat', sans-serif",
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '10px',
    xl: '0.75rem',
    full: '50em',
  },
  spacing: (n) => `${n * 0.25}rem`,
  shadows: {
    card: '0px 1px 8px 0px rgba(0,0,0,0.12),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.20)',
  },
}

export default theme
